import React from "react"
import GenericEditIcon from "../../../../components/GenericEditIcon"
import { KFC_BRANDS } from "../../../../utils"
import { packagingNature } from "../../../../utils/packaging"
import PropertiesPanel from "../../../../components/common/PropertiesPanel"

const DistributionCenterResume = ({ distributionCenter = {}, onEdit }) => {
	return (
		<PropertiesPanel
			title="Résumé du centre de distribution"
			icons={<GenericEditIcon onEdit={onEdit} />}
			properties={{
				"Nom": distributionCenter.name,
				"Code": distributionCenter.code,
				"Id externe (NU)": distributionCenter.externalId,
				"Marque": KFC_BRANDS.find(brand => brand.name === distributionCenter.brand)?.label,
				"Ville de rattachement": distributionCenter.sector,
				"Type de packaging": distributionCenter && distributionCenter.packagingTypes ? distributionCenter.packagingTypes.map(el => { return packagingNature.find(e => e.value === el).label }).join(", ") : "",
				"Priorité": distributionCenter.dispatch?.priority,
				"Zéro plastique": distributionCenter.zeroWaste ? "Oui" : "Non",
				"Actif": distributionCenter.isActive ? "Oui" : "Non",
				"Province": distributionCenter.national ? "Oui" : "Non",
				"Seulement précommande": distributionCenter.onlyPreorders ? "Oui" : "Non",
				"Offre retail active": distributionCenter.activeRetailOffer ? "Oui" : "Non"
			}}
		/>
	)
}

export default DistributionCenterResume